import { LOGO_BG_RE } from './logo-compose';

interface KlientLogoBgPickerProps {
  value: string | null;
  onChange: (value: string | null) => void;
  disabled?: boolean;
}

export function KlientLogoBgPicker({ value, onChange, disabled }: KlientLogoBgPickerProps) {
  const custom = value != null && LOGO_BG_RE.test(value);
  return (
    <div className="aff-editor-logo-bg">
      <span className="aff-editor-logo-bg-label">Pozadí loga</span>
      <div className="aff-editor-logo-bg-options">
        <button type="button" className={`aff-editor-logo-bg-chip ${custom ? '' : 'is-active'}`} disabled={disabled} onClick={() => onChange(null)}>
          <i aria-hidden="true" style={{ background: '#fff' }} /> Bílé
        </button>
        <button type="button" className={`aff-editor-logo-bg-chip ${custom ? 'is-active' : ''}`} disabled={disabled} onClick={() => onChange(custom ? value : '#000000')}>
          <i aria-hidden="true" style={{ background: custom ? value : '#000000' }} /> Vlastní barva
        </button>
        {custom && (
          <label className="aff-editor-logo-bg-color">
            <input type="color" value={value} disabled={disabled} onChange={(e) => onChange(e.target.value.toLowerCase())} aria-label="Barva pozadí loga" />
            <code>{value}</code>
          </label>
        )}
      </div>
      <small className="aff-editor-help">{custom ? 'Logo se při nahrání vloží na zvolené pozadí a takto se zobrazí všude (karta, Promo News, mailing).' : 'Logo se uloží tak, jak je, a zobrazuje se na bílém pozadí.'}</small>
    </div>
  );
}
